/**
 * Could be used in the render functions
 *
 * &nbsp; space
 *
 * @param {function} h - createElement function
 * @param {string} [tag=span] - wrapper tag node type
 * @returns {*}
 */

export default (h, tag = 'span') => h(tag, {
    domProps: {
        innerHTML: '&nbsp;',
    },
});
